/**
 * Orders items for a list titled by section: the unsectioned ones first, then each section's items
 * together, sections in the order they first appear. `titleAt` maps the index that opens a section
 * to its title.
 */
export function groupBySection<T>(
  items: readonly T[],
  sectionOf: (item: T) => string | undefined
): { items: T[]; titleAt: Map<number, string> } {
  const buckets = new Map<string | undefined, T[]>([[undefined, []]]);
  for (const item of items) {
    const section = sectionOf(item);
    const bucket = buckets.get(section);
    if (bucket) bucket.push(item);
    else buckets.set(section, [item]);
  }

  const grouped: T[] = [];
  const titleAt = new Map<number, string>();
  for (const [section, bucket] of buckets) {
    if (section !== undefined && bucket.length) titleAt.set(grouped.length, section);
    grouped.push(...bucket);
  }
  return { items: grouped, titleAt };
}
